import React from 'react';
import InputSync from 'components/InputSync';
import styles from 'components/InputWhite.css';
import stylesProgressBar from 'components/syncingInputProgressBarWhite.css';

const InputWhite = props =>
  <InputSync
    inputTheme={styles}
    progressBarTheme={stylesProgressBar}
    {...props}
  />;

export default InputWhite;
